import { Environment } from '@src/environment';

export async function updateKeycloakLocale(
  accessToken: string,
  locale: string,
): Promise<void> {
  const accountUrl = `${Environment.OIDC_AUTHORITY}/account/`;
  const headers = {
    'Authorization': `Bearer ${accessToken}`,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };

  const response = await fetch(accountUrl, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(
      `Failed to fetch Keycloak account: ${String(response.status)}`,
    );
  }

  const accountData = (await response.json()) as Record<string, unknown>;

  const attributes = (accountData.attributes ?? {}) as Record<string, unknown>;

  await fetch(accountUrl, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      ...accountData,
      attributes: {
        ...attributes,
        locale: [locale],
      },
    }),
  });
}
